"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertFilterSchemaSecurity = assertFilterSchemaSecurity;
const tenant_scoped_query_builder_1 = require("./tenant-scoped-query-builder");
const types_1 = require("./types");
const ATTACK_FIELD_NAMES = [
    '__proto__',
    'constructor',
    'toString',
    'prototype',
    'project.organizationId',
    'build.id',
    'org.id',
];
function assertFilterSchemaSecurity(schema, options) {
    const tenancy = options?.tenancyClause ?? { buildId: 'test-build-id' };
    const reserved = options?.reservedColumns ?? types_1.DEFAULT_RESERVED_COLUMNS;
    if (!schema.__validated) {
        throw new Error('Schema was not created via createFilterSchema(). ' +
            'Construct schemas with createFilterSchema() to ensure startup validation runs.');
    }
    for (const fieldName of Object.keys(schema.fields)) {
        for (const col of reserved) {
            if (fieldName === col) {
                throw new Error(`Field "${fieldName}" is a reserved tenancy column and should not be in the schema.`);
            }
        }
    }
    for (const attackField of ATTACK_FIELD_NAMES) {
        const tree = (0, tenant_scoped_query_builder_1.flatFiltersToTree)([{ field: attackField, operator: 'equals', value: 'test' }]);
        const { rejected } = (0, tenant_scoped_query_builder_1.buildTenantScopedWhere)(tenancy, schema, tree);
        if (!rejected.includes(attackField)) {
            throw new Error(`Attack field name "${attackField}" was not rejected. ` + `Expected it to appear in the rejected list.`);
        }
    }
    for (const col of reserved) {
        const tree = (0, tenant_scoped_query_builder_1.flatFiltersToTree)([{ field: col, operator: 'equals', value: 'attacker-value' }]);
        const { rejected } = (0, tenant_scoped_query_builder_1.buildTenantScopedWhere)(tenancy, schema, tree);
        if (!rejected.includes(col)) {
            throw new Error(`Reserved column "${col}" was accepted as a filter field. ` + `It should be rejected by the field whitelist.`);
        }
    }
    const schemaFields = Object.keys(schema.fields);
    const field1 = schemaFields[0];
    if (!field1) {
        throw new Error('Schema has no fields — cannot run OR-escape test.');
    }
    const field2 = schemaFields[1] ?? field1;
    const tree = (0, tenant_scoped_query_builder_1.flatFiltersToTree)([
        { field: field1, operator: 'equals', value: 'a' },
        { field: field2, operator: 'equals', value: 'b' },
    ], types_1.LOGIC_OPERATORS.OR);
    const { where } = (0, tenant_scoped_query_builder_1.buildTenantScopedWhere)(tenancy, schema, tree);
    if (!where.AND || !Array.isArray(where.AND)) {
        throw new Error('OR filter output is not wrapped in top-level AND.');
    }
    const andArray = where.AND;
    const firstClause = JSON.stringify(andArray[0]);
    const tenancyStr = JSON.stringify(tenancy);
    if (firstClause !== tenancyStr) {
        throw new Error(`Tenancy clause is not first in AND array. ` + `Expected ${tenancyStr}, got ${firstClause}.`);
    }
}
//# sourceMappingURL=filter-schema-test-utils.js.map